import React from "react";
import { MemoriesList } from "../features/memory/components/MemoriesList";
import { useLastAccessedTime } from "../features/lastaccessedtime/useLastAccessedTime";
import { useMemories } from "../features/memory/hooks/useMemories";

export const HomePage: React.FC = () => {
    useLastAccessedTime();
    const {
        memories,
        isMemoriesLoading,
        incrementLikedCount,
        tempLikedMemoryIds,
        hasNextPage,
        fetchNextPage,
        isFetchingNextPage,
    } = useMemories();
    return (
        <MemoriesList
            memories={memories}
            isLoading={isMemoriesLoading}
            emptyMessage="まだ回答がされていないようです…もうしばらくお待ち下さい"
            incrementLikedCount={incrementLikedCount}
            tempLikedMemoryIds={tempLikedMemoryIds}
            hasNextPage={hasNextPage}
            fetchNextPage={fetchNextPage}
            isFetchingNextPage={isFetchingNextPage}
        />
    );
};
